import { redirect } from '@adjust/dashboard-core/lib/utils/location';
import { PaymentTheme } from '@lib/braintree/braintree';

import { updateCard, createInstance } from '@redux/ducks/paymentMethods';
import { isPricingPlanConfirmed } from '@redux/ducks/account/pricingPlan/changePricingPlan';

/**
 * @ngdoc controller
 * @name adjust.accountSettings.controller:PaymentSetupController
 *
 * @description
 * Payment setup controller
 *
 */
function PaymentSetupController(Account, User, $q, $scope, $state, $timeout, $ngRedux) {
  'ngInject';
  const vm = this;

  vm.STEPS = {
    BILLING_DETAILS: 'billing-details',
    CREDIT_CARD_DETAILS: 'credit-card-details',
    PAYMENT_PLAN: 'payment-plan',
    FINISH: 'finish',
  };

  vm.stepsOrder = [
    vm.STEPS.BILLING_DETAILS,
    vm.STEPS.CREDIT_CARD_DETAILS,
    vm.STEPS.PAYMENT_PLAN,
    vm.STEPS.FINISH
  ];

  vm.currentStep = vm.STEPS.BILLING_DETAILS;

  vm.finishStep = finishStep;
  vm.goToApps = goToApps;
  vm.autoRedirectTimer = autoRedirectTimer;
  vm.getStep = getStep;
  vm.handleOnSubmit = (params) => vm.updateCard(params);

  const _mapStateToVm = state => {
    // TODO: ADAPP-2032 Temporary solution to avoid huge changes. Should be removed.
    if (vm.currentStep === vm.STEPS.PAYMENT_PLAN && isPricingPlanConfirmed(state)) {
      finishStep(vm.STEPS.PAYMENT_PLAN);
    }

    return {
      state: state.paymentMethods
    };
  };

  const _mapDispatchToVm = {
    createInstance,
    updateCard
  };

  vm.$onInit = () => {
    Account
      .getCurrent()
      .then(_initializeNewFeatureScope)
      .then(getStep)
      .then(function(step) {
        vm.currentStep = step;
        _handleCreateInstance();
      });

    const unsubscribe = $ngRedux.connect(_mapStateToVm, _mapDispatchToVm)(vm);
    $scope.$on('$destroy', unsubscribe);

    $scope.$watch('vm.state.isSuccess', _handleCreditCardSaveSuccess);
  };

  function _initializeNewFeatureScope(currentAccount) {
     vm.isNewFeatureScopeActive = Account.hasNewFeatureScope(currentAccount);
     return currentAccount;
  }

  /**
   * @ngdoc method
   * @name getStep
   * @methodOf adjust.accountSettings.controller:PaymentSetupController
   *
   * @description
   * Get the current step depending on the account's state
   *
   * @returns {integer} step number
   */
  function getStep(account) {
    if (account.address.complete && account.billing_currency && account.has_payment_method) {
      return (account.payment_plan || Account.hasNewFeatureScope(account)) ? vm.STEPS.FINISH : vm.STEPS.PAYMENT_PLAN;
    }

    if (account.address.complete && account.billing_currency) {
      return vm.STEPS.CREDIT_CARD_DETAILS;
    }

    return vm.STEPS.BILLING_DETAILS;
  }

  /**
   * @ngdoc method
   * @name goToApps
   * @methodOf adjust.accountSettings.controller:PaymentSetupController
   *
   * @description
   * Handle the package update, clean the user's cache and go to the apps route
   *
   */
  function goToApps() {
    $q.all([
      User.getCurrentForcingUpdate(),
      Account.getCurrentForcingUpdate()
    ])
      .then(() => redirect('/' + $state.href('apps')));
  }

  /**
   * @ngdoc method
   * @name autoRedirectTimer
   * @methodOf adjust.accountSettings.controller:PaymentSetupController
   *
   * @description
   * Timer for auto redirection to apps page on finish step
   *
   */
  function autoRedirectTimer() {

    $timeout(goToApps, 5000);

  }

  function getNextStep(step) {
    const index = vm.stepsOrder.findIndex(value => value === step);

    if (step === vm.STEPS.CREDIT_CARD_DETAILS && vm.isNewFeatureScopeActive) {
      return vm.STEPS.FINISH;
    }

    return vm.stepsOrder[index + 1];
  }

  /**
   * @ngdoc method
   * @name finishStep
   * @methodOf adjust.accountSettings.controller:PaymentSetupController
   *
   * @description
   * Finish the passed step and go to the next
   *
   */
  function finishStep(step, account) {

    vm.currentStep = angular.isDefined(account) ?
      getStep(account) :
      getNextStep(step);

    _handleCreateInstance();
  }

  /**
   * @private
   */
  function _handleCreateInstance() {
    if (vm.currentStep === vm.STEPS.CREDIT_CARD_DETAILS) {
      vm.createInstance(PaymentTheme.Dark);
    }
  }

  /**
   * @param {Boolean} isSuccess
   * @private
   */
  function _handleCreditCardSaveSuccess(isSuccess) {
    if (isSuccess) {
      vm.finishStep(vm.STEPS.CREDIT_CARD_DETAILS);
    }
  }
}

export {PaymentSetupController};
